var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowsDiagrams = function SvgArrowsDiagrams(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#arrows_diagrams_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.541 14.673 1.5-1.5-1.5-1.5M7.928 7.188 6.743 5.56a1.501 1.501 0 0 0-1.22-.618l-2.982.013M14.541 6.438l1.5-1.5-1.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.654 10.938 1.185 1.63c.284.39.737.619 1.22.617l2.982-.012M16.041 4.954l-2.982-.013a1.5 1.5 0 0 0-1.22.618l-5.096 7.008c-.284.39-.738.62-1.22.618l-2.982-.012"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrows_diagrams_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z",
    transform: "translate(.291 .438)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowsDiagrams);
export default ForwardRef;